'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = require('react-redux');

var _AbstractReactComponent = require('../AbstractReactComponent');

var _AbstractReactComponent2 = _interopRequireDefault(_AbstractReactComponent);

var _utils = require('../utils');

var _FrameActions = require('./FrameActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ie9 = navigator.userAgent.indexOf('MSIE 9.0') >= 0;

/**
 * IFrame komponenta s možností vzájemné komunikace.
 */

var Frame = function (_AbstractReactCompone) {
    (0, _inherits3.default)(Frame, _AbstractReactCompone);

    function Frame() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Frame);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Frame.__proto__ || (0, _getPrototypeOf2.default)(Frame)).call.apply(_ref, [this].concat(args))), _this), _this.handleMessage = function (e) {
            var _this$props = _this.props,
                src = _this$props.src,
                onMessage = _this$props.onMessage;

            if (src && e.origin && src.toLowerCase().indexOf(e.origin.toLowerCase()) === 0) {
                // Zprava mohla prijit i od jineho window, musime kontrolovat origin!
                // Porovnání hostname v origin musí být case-insensitive!
                // I když má iframe src URL ve formátu http://HOST.EXAMPLE/path,
                // prohlížeč může v eventu posílat lower-case variantu http://host.example/path.
                var data = ie9 ? JSON.parse(e.data) : e.data; // IE9 podporuje pouze string data => serializace
                onMessage(data);
            }
        }, _this.processMessagesIfNeeded = function (props) {
            var area = props.area,
                _props$frame = props.frame,
                postSuspended = _props$frame.postSuspended,
                messages = _props$frame.messages;

            if (!postSuspended && messages && messages.length > 0) {
                messages.forEach(function (msg) {
                    _this._postMessage(msg);
                });
                _this.dispatch((0, _FrameActions.clearMessages)(area));
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Frame, [{
        key: '_postMessage',
        value: function _postMessage(data) {
            var dataForSend = ie9 ? (0, _stringify2.default)(data) : data; // IE9 podporuje pouze string data => serializace
            var frame = _reactDom2.default.findDOMNode(this.refs.frame);
            frame.contentWindow.postMessage(dataForSend, '*');
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('message', this.handleMessage);
            this.processMessagesIfNeeded(this.props);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.processMessagesIfNeeded(nextProps);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('message', this.handleMessage);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                src = _props.src,
                area = _props.area,
                frame = _props.frame,
                onMessage = _props.onMessage,
                dispatch = _props.dispatch,
                otherProps = (0, _objectWithoutProperties3.default)(_props, ['src', 'area', 'frame', 'onMessage', 'dispatch']);

            return _react2.default.createElement('iframe', (0, _extends3.default)({ ref: 'frame', src: src }, otherProps));
        }
    }]);
    return Frame;
}(_AbstractReactComponent2.default);

Frame.PropTypes = {
    src: _react2.default.PropTypes.string.isRequired,
    area: _react2.default.PropTypes.string.isRequired,
    frame: _react2.default.PropTypes.object.isRequired,
    onMessage: _react2.default.PropTypes.func.isRequired
};
Frame.defaultProps = {
    // area: null,
};


function mapStateToProps(state, props) {
    return {
        frame: (0, _utils.storeFromArea)(state, props.area)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Frame);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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